import { jsx as _jsx } from "react/jsx-runtime";
import { AccessDeniedMessageBox, CardHoldersErrors, ConfirmedUserAdded, EligibleMemberList, ExistingUser, UserFormSams, VerifyMessageBox } from '../main-container/components';
import { CardholdersScreen } from '../typings';
const displayModalScreen = (screenType) => {
    const modalScreenMap = {
        [CardholdersScreen.ACCESS_DENIED_SCREEN]: _jsx(AccessDeniedMessageBox, {}),
        [CardholdersScreen.ADD_AUTH_USER]: null,
        [CardholdersScreen.ADD_AUTH_USER_SAMS]: _jsx(UserFormSams, {}),
        [CardholdersScreen.ADD_AUTH_USER_SAMS_LIST]: _jsx(EligibleMemberList, {}),
        [CardholdersScreen.CONFIRMATION_SCREEN_NEW_USER]: _jsx(ConfirmedUserAdded, {}),
        [CardholdersScreen.CONFIRMATION_SCREEN_EXISTING_USER]: _jsx(ExistingUser, {}),
        [CardholdersScreen.ERROR_SCREEN]: (_jsx(CardHoldersErrors, { ...screenType.customData })),
        [CardholdersScreen.INITIAL_SCREEN]: null,
        [CardholdersScreen.VERIFY_USER_SCREEN]: _jsx(VerifyMessageBox, {})
    };
    return modalScreenMap[screenType.screen] || null;
};
export default displayModalScreen;
